import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { actions } from "../../../../store/modules";
import i18n from "../../../../plugins/i18n/i18n";
import moment from "moment";
import { List, Spin, Badge, Avatar } from 'antd';
import { FieldTimeOutlined, RightOutlined } from '@ant-design/icons';
import { isMobile } from "../../../../helpers";

const type = "notifications";

class NotificationList extends Component {

    constructor(props) {
        super(props);
        this.endpoint = { keyOne: type };
        this.state = {
            isResponsive: false,
            dataActives: [],
            totalActives: 0,
            loadings: {
                data: false
            },
            hasMore: true
        };
        this.filter = {
            sort: "date-desc"
        }
    }

    componentWillMount() {
        if (isMobile()) {
            this.setState({
                isResponsive: true,
            });
        }

        this.getData();
        this.props.dispatch(actions.auth.getAccount());

    }

    getData = () => {

        let { loadings } = this.state;
        loadings.data = true;

        this.setState({ loadings });

        this.props.dispatch(actions.definitions.getData({
            ...this.endpoint,
            filter: this.filter
        })).then(response => {
            loadings.data = false;

            this.setState({
                dataActives: response.data,
                totalActives: response.total,
                loadings
            });


        })
            .catch(error => {

                loadings.data = false;

                this.setState({
                    loadings
                });
            })
    }


    render() {

        let { loadings, dataActives } = this.state;

        return (

            <Fragment>
                {
                    loadings.data &&
                    <div className="ant-loading loading-content">
                        <Spin
                            tip={`${i18n.t(`loading`, {
                                lng: this.props.currentLanguage,
                            })}`}
                        />
                    </div>
                }

                {
                    !loadings.data &&
                    <div
                        className='list-container notifications'
                    >

                        <List
                            // className='content-list'
                            // grid={{
                            //     gutter: 16,
                            //     xs: 3,
                            //     sm: 3,
                            //     md: 3,
                            //     lg: 3,
                            //     xl: 3,
                            //     xxl: 3,
                            // }}
                            itemLayout="horizontal"
                            // locale={{
                            //     emptyText: <Empty
                            //         image={Empty.PRESENTED_IMAGE_DEFAULT}
                            //         imageStyle={{
                            //             height: 60,
                            //         }}
                            //         description={
                            //             <span>
                            //                 Bildiriminiz bulunmuyor.
                            //             </span>
                            //         }
                            //     >
                            //     </Empty>
                            // }}
                            dataSource={dataActives}
                            renderItem={(item) => (

                                <Badge.Ribbon text="Yeni" color="#32a852" style={{ display: item.isRead ? "none" : "unset" }}>
                                    <List.Item
                                        extra={
                                            <RightOutlined />
                                        }
                                        onClick={() => this.props.history.push(`/app/trips/${item.contentId}`)}
                                    >

                                        <List.Item.Meta
                                            avatar={<Avatar size={60} icon={<FieldTimeOutlined />} />}
                                            title={item.subject}
                                            description={<Fragment>
                                                <div>{item.message}</div>
                                                <div className='date'>{moment(item.date).format("DD MMMM YYYY HH:mm")}</div>
                                            </Fragment>}
                                        />
                                    </List.Item>
                                </Badge.Ribbon>
                            )}
                        />

                    </div>
                }
            </Fragment >

        );
    }
}

const mapStateToProps = ({ account }) => ({ ...account });
export default connect(mapStateToProps)(NotificationList);


// WEBPACK FOOTER //
// ./src/components/App/Views/Notification/NotificationList.js